/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable no-dupe-keys */
import PageFooter from "../../shared/app-shell/PageFooter";
import { themeAtom } from "../../shared/atoms";
import LoadingWrapper from "../../shared/components/LoadingWrapper";
import ResponsiveTable from "../../shared/components/ResponsiveTable";
import { api, apiUrl } from "../../shared/services/service";
import DynamicReadOnlyForm from "../components/DynamicReadOnlyForm";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";

interface AntiFoulingDetail {
  DATE: any;
  PORT: any;
  "HULL INSPECTED": any;
  "HULL CLEANED": any;
  "AREAS CLEANED": any;
  "PROPELLER POLISHED": any;
  "NZ MPI STANDARD": any;
}
interface Item {
  id: number;
  name: string;
  noOfItems: string | number;
  powerConsumptions: string | number;
  typeOfPower: string;
  makerModel: string;
}
interface WlthcForm {
  WLTHC_BALLAST_NO1: string;
  WLTHC_BALLAST_MIDSHIPS: string;
  WLTHC_BALLAST_LAST: string;
  WLTHC_FULL_BALLAST_NO1: string;
  WLTHC_FULL_BALLAST_MIDSHIPS: string;
  WLTHC_FULL_BALLAST_LAST: string;
  WLTHC_FULLY_LADEN_NO1: string;
  WLTHC_FULLY_LADEN_MIDSHIPS: string;
  WLTHC_FULLY_LADEN_LAST: string;
}

const formatTechFormMeasurement = (value: unknown, unit: string) => {
  const text = String(value ?? "").trim();

  return text ? `${text} ${unit}` : "";
};

// Shows the latest persisted technical-form values in vessel-readable sections.
// Highlights offline submissions and vessels that completed Tech Forms under multiple time-charter contracts.
const TechnicalInformationTab = () => {
  const theme = useAtomValue(themeAtom);

  const { imoNumber, vesselName } = useParams();
  const [vesselDetailsForm, setVesselDetailsForm] = useState({});
  const [technicalFormSubmitted, setTechnicalFormSubmitted] = useState("");
  const [technicalFormSubmittedOffline, setTechnicalFormSubmittedOffline] = useState(false);
  const [technicalFormRejoinedFleet, setTechnicalFormRejoinedFleet] = useState(false);
  const [wlthcForm, setWlthcForm] = useState<WlthcForm>();
  const [vesselDesignForm, setVesselDesignForm] = useState({});
  const [vesselDesignBallastForm, setVesselDesignBallastForm] = useState({});
  const [vesselDesignDeballastForm, setVesselDesignDeballastForm] = useState({});
  const [summerDraftForm, setSummerDraftForm] = useState({});
  const [winterDraftForm, setWinterDraftForm] = useState({});
  const [otherDraftForm, setOtherDraftForm] = useState([]);
  const [antiFoulingDetailsForm, setAntiFoulingDetailsForm] = useState({});
  const [antiFoulingDetailsFormTable, setAntiFoulingDetailsFormTable] = useState<AntiFoulingDetail[]>([]);
  const [secaForm, setSecaForm] = useState({});
  const [slowStreamingForm, setSlowStreamingForm] = useState({});
  const [powerForm, setPowerForm] = useState({});
  const [powerManagementTableDataForm, setPowerManagementTableDataForm] = useState<Item[]>([]);
  const [lastPortCallsForm, setLastPortCallsForm] = useState<Item[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const queryParams = {
    imo_no: imoNumber,
    vessel_name: vesselName,
  };
  const vesselDetailsFormFetchData = async () => {
    try {
      setIsLoading(true);
      const result = await api.get(`${apiUrl}/td_General_Info`, {
        params: queryParams,
      });

      setTechnicalFormSubmitted(result.data[0]?.TECH_FORM_SUBMITTED || "");
      setTechnicalFormSubmittedOffline(result.data[0]?.TECH_FORM_SUBMITTED_OFFLINE === true);
      setTechnicalFormRejoinedFleet(result.data[0]?.TECH_FORM_REJOINED_FLEET === true);

      const stepOneData = result.data[0];
      const _vesselDetailsForm = {
        Inmarsat: stepOneData?.INMARSAT || "",
        "Max crane outreach(m)": stepOneData?.MAX_CRANE_OUTREACH || "",
        "GT/NT": stepOneData?.GT_NT || "",
        "Call Sign": "",
        "Moulded Depth": formatTechFormMeasurement(stepOneData?.MOULDED_DEPTH, "m"),
        "Right handed propeller": stepOneData?.CONFIRM_SHIP_HAS_RIGHT_HANDED_PROPELLER || "",
        "Height of Vessel": stepOneData?.HEIGHT_OF_VESSEL || "",
        LOA: formatTechFormMeasurement(stepOneData?.LOA, "m"),
        LBP: stepOneData?.LBP || "",
        Beam: stepOneData?.BEAM || "",
        Lightweight: stepOneData?.LIGHT_WEIGHT || "",
        "Hold Capacity (Grain)": formatTechFormMeasurement(stepOneData?.TOTAL_HOLD_CAPACITY_GRAIN_M3, "m3"),
        "Hold Capacity (Bale)": formatTechFormMeasurement(stepOneData?.TOTAL_HOLD_CAPACITY_BALE_M3, "m3"),
        Constant: stepOneData?.CONSTANT || "",
        "Fresh water capacity": stepOneData?.FRESH_WATER_CAPACITY || "",
        "Block Coefficient": stepOneData?.BLOCK_COEFICIENT || "",
        "Modification since newbuilt": stepOneData?.ANY_MODIFICATIONS_MADE_SINCE_NEWBUILT_THAT_AFFECT_CONSUMPTION || "",
      };

      setVesselDetailsForm(_vesselDetailsForm);
      setWlthcForm(stepOneData);

      setIsLoading(false);
    } catch (error: unknown) {
      setIsLoading(false);
    }
  };
  const vesselDesignFormsFormFetchData = async () => {
    try {
      setIsLoading(true);
      const result = await api.get(`${apiUrl}/td_Vessel_Design`, {
        params: queryParams,
      });
      const stepTwoData = result.data[0];
      const vdForm = {
        "Alternate hold loading": stepTwoData?.ALTERNATE_HOLD_LOADING || "",
        "Port ballast Hold number": stepTwoData?.PORT_BALLAST_HOLD_NUMBER_VAL || "",
        "Sea ballast Hold number": stepTwoData?.SEA_BALLAST_HOLD_NUMBER_VAL || "",
        "Ballast Water Treatment System": stepTwoData?.BALLAST_WATER_TREATMENT_SYSTEM,
        "Dimensions of cement holes": formatTechFormMeasurement(stepTwoData?.DIMENSIONS_OF_CEMENT_HOLES, "mm"),
      };
      const vdBallastForm = {
        Gravity: stepTwoData?.BALLSTING_RATE_USING || "",
        "Ballast pumps": stepTwoData?.BALLAST_PUMPS || "",
        "Ship has EEDI or EVDI Rating": stepTwoData?.EEDI_EVDI_RATING || "",
        "NOx Tier III engine fuel grade": stepTwoData?.NOX_TIER_III_ENGINE_FUEL_GRADE || "",
        "Shaft Power Meter fitted": stepTwoData?.FITTED_WITH_SHAFT_POWER_METER || "",
        "Number of cement holes": stepTwoData?.NO_OF_CEMENT_HOLES || "",
        "Scrubber fitted": stepTwoData?.SCRUBBER_FITTED || "",
      };
      const vdDeballastForm = {
        Gravity: stepTwoData?.DEBALLSTING_RATE_USING || "",
        "Ballast pumps": stepTwoData?.DEBALLAST_PUMPS || "",
        "Fitted with mass flow meters to measure fuel consumption":
          stepTwoData?.FITTED_WITH_MASS_FLOW_METERS_TO_MEASURE_FUEL_CONSUMPTION || "",
        "Fitted with sensors/devices recording performance data?":
          stepTwoData?.FITTED_WITH_THAT_IS_AUTOMATICALLY_RECORDING || "",
        "Sensors and Data Acquisition System Maker Name": stepTwoData?.SENSORS_AND_DATA_ACQUISTION_SYSTEM_MAKER || "",
        "Scrubber type": stepTwoData?.SCRUBBER_TYPE_VAL || "",
        "Scrubber maker": stepTwoData?.SCRUBBER_MAKER || "",
        "Vessel aux. boiler connected to scrubber": stepTwoData?.IS_VESSEL_AUX_BOILER_CONNECTED_TO_SCRUBBER || "",
      };

      setVesselDesignForm(vdForm);
      setVesselDesignBallastForm(vdBallastForm);
      setVesselDesignDeballastForm(vdDeballastForm);
      setIsLoading(false);
    } catch (error: unknown) {
      setIsLoading(false);
    }
  };
  const draftFormsFormFetchData = async () => {
    try {
      setIsLoading(true);
      const result = await api.get(`${apiUrl}/td_Vessel_Draft_SummerWinter`, {
        params: queryParams,
      });
      const tableresult = await api.get(`${apiUrl}/td_Vessel_Draft`, {
        params: queryParams,
      });
      const stepThreeData = result.data[0];
      const draftTableData = tableresult.data;
      const summerDraft = {
        "SW draft": stepThreeData?.SUMMER_SW_DRAFT,
        DWT: stepThreeData?.SUMMER_DWT,
        TPC: stepThreeData?.SUMMER_TPC,
      };
      const winterDraft = {
        SWDraft: stepThreeData?.WINTER_SW_DRAFT,
        DWT: stepThreeData?.WINTER_DWT,
        TPC: stepThreeData?.WINTER_TPC,
      };
      const otherDrafts = draftTableData.sort((a: { ID: string }, b: { ID: string }) => {
        return Number(a.ID) - Number(b.ID);
      });

      setSummerDraftForm(summerDraft);
      setWinterDraftForm(winterDraft);
      setOtherDraftForm(otherDrafts);
      setIsLoading(false);
    } catch (error: unknown) {
      setIsLoading(false);
    }
  };
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    if (!dateString || Number.isNaN(date.getTime()) || date.getFullYear() === 1970) {
      return "N/A";
    }
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const antiFoulingFormFetchData = async () => {
    try {
      setIsLoading(true);
      const result = await api.get(`${apiUrl}/td_Antifouling_Details`, {
        params: queryParams,
      });

      const stepFourData = result.data[0];

      const _antiFoulingDetailsForm = {
        "Issuance Antifouling Certificate": formatDate(stepFourData?.DATE_OF_ISSUANCE_ANTI_FOULING_CERTIFICATE),
        "Paint application": formatDate(stepFourData?.DATE_OF_PAINT_APPLICATION),
        "Type of Antifoouling system as per certificate": stepFourData?.TYPE_OF_ANTI_FOULING_SYSTEM_LABEL,
        "Antifouling system(s) manufacturer": stepFourData?.ANTI_FOULING_SYSTEM_MANUFACTURER_VALUE,
        "Antifouling system(s)": `${stepFourData?.NAME_OF_ANTI_FOULING_SYSTEM_ONE_VALUE},${stepFourData?.NAME_OF_ANTI_FOULING_SYSTEM_TWO_VALUE},${stepFourData?.NAME_OF_ANTI_FOULING_SYSTEM_THREE_VALUE}`,
        "Last dry-docking date": formatDate(stepFourData?.LAST_DRY_DOCKING_DATE),
        "Under-water hull inspection after last dry dock?":
          stepFourData?.HAS_UNDERWATER_HULL_INSPECTION_AFTER_LAST_DRY_DOCK,
        "Last dry-docking location/yard built": stepFourData?.LAST_DRY_DOCKING_LOCATION,
        "Anti Fouling coating on Vertical Bottom": stepFourData?.ANTI_FOULING_VERTICAL_BOTTOM_COATING,
        "Anti Fouling coating on Flat Bottom": stepFourData?.ANTI_FOULING_FLAT_BOTTOM_COATING,
        "Anti Fouling coating on Boot Top": stepFourData?.ANTI_FOULING_BOOT_TOP_COATING,
        "Service life of AFS": formatTechFormMeasurement(stepFourData?.SERVICE_LIFE_AFS_MONTHS, "months"),
        "Propeller painted/coated?": stepFourData?.PROPELLER_PAINTED_COATED,
        "Is there a procedure placed by owners for regular UWI/UWC?":
          stepFourData?.IS_THERE_A_PROCEDURE_PLACED_BY_OWNERS,
        "Frequency of scheduled inspections / cleanings": stepFourData?.FREQUENCY_OF_SCHEDULED_INSPECTIONS,
      };
      const antifoulingTable = [
        {
          DATE: stepFourData?.UNDER_WATER_HULL_CLEANING_DATE_ONE,
          PORT: stepFourData?.UNDER_WATER_HULL_CLEANING_PORT_NAME_ONE,
          "HULL INSPECTED": stepFourData?.UNDER_WATER_HULL_CLEANING_HULL_INSPECTED_ONE,
          "HULL CLEANED": stepFourData?.UNDER_WATER_HULL_CLEANING_HULL_CLEANED_ONE,
          "AREAS CLEANED": stepFourData?.UNDER_WATER_HULL_CLEANING_AREAS_CLEANED_ONE,
          "PROPELLER POLISHED": stepFourData?.UNDER_WATER_HULL_CLEANING_PROPELLER_POLISHED_ONE,
          "NZ MPI STANDARD": stepFourData?.UNDER_WATER_HULL_CLEANING_NZ_MPI_STANDARD_CLEANING_ONE,
        },
        {
          DATE: stepFourData?.UNDER_WATER_HULL_CLEANING_DATE_TWO,
          PORT: stepFourData?.UNDER_WATER_HULL_CLEANING_PORT_NAME_TWO,
          "HULL INSPECTED": stepFourData?.UNDER_WATER_HULL_CLEANING_HULL_INSPECTED_TWO,
          "HULL CLEANED": stepFourData?.UNDER_WATER_HULL_CLEANING_HULL_CLEANED_TWO,
          "AREAS CLEANED": stepFourData?.UNDER_WATER_HULL_CLEANING_AREAS_CLEANED_TWO,
          "PROPELLER POLISHED": stepFourData?.UNDER_WATER_HULL_CLEANING_PROPELLER_POLISHED_TWO,
          "NZ MPI STANDARD": stepFourData?.UNDER_WATER_HULL_CLEANING_NZ_MPI_STANDARD_CLEANING_TWO,
        },
      ];
      setAntiFoulingDetailsForm(_antiFoulingDetailsForm);
      setAntiFoulingDetailsFormTable(antifoulingTable);

      setIsLoading(false);
    } catch (error: unknown) {
      setIsLoading(false);
    }
  };

  const secaFormfetchData = async () => {
    try {
      setIsLoading(true);
      const result = await api.get(`${apiUrl}/td_Seca`, {
        params: queryParams,
      });
      const stepSixData = result.data[0];
      const _secaForm = {
        "Capacity of the LSFO mixing / dearation tank": `${stepSixData?.CAPACITY} mt`,
        "Unpumpable quantity/capacity (if any) of the LSFO settling tank": `${stepSixData?.UNPUMPABLE} mt`,
        "Minimum feasible level (% full) of the LSFO service tank": `${stepSixData?.LSFO_SERVICE_TANK}%`,
        "Minimum feasible time for draining the service tank completely": `${stepSixData?.MINIMAL_FEASBLE} h`,
      };
      setSecaForm(_secaForm);
      setIsLoading(false);
    } catch (error: unknown) {
      setIsLoading(false);
    }
  };
  const slowStreamingFormFetchData = async () => {
    try {
      setIsLoading(true);
      const result = await api.get(`${apiUrl}/td_Slow_Steaming`, {
        params: queryParams,
      });
      const stepSevenData = result.data[0];
      const _slowStreamingForm = {
        "Propeller Pitch": `${stepSevenData?.PROPELLER_PITCH} m`,
        "Propeller Diameter": `${stepSevenData?.PROPELLER_DIAMETER} m`,
        "main Engine Maker & Model": stepSevenData?.MAIN_ENGINE_MAKER_MODEL,
        "engine Tuning": stepSevenData?.ENGINE_TUNING,
        "NOx Tier III compliance method": stepSevenData?.NOX_TIER_III_COMPLIANCE_METHOD,
        "main Engine MCR Rating": `${stepSevenData?.MAIN_ENGINE_MCR_RATING} m`,
        "Engine equipped with power limited EPL/ShaPoLi?": stepSevenData?.ENGINE_EQUIPPED_WITH_POWER_LIMITED,
        "Main Engine Limited Power Rating": formatTechFormMeasurement(
          stepSevenData?.MAIN_ENGINE_LIMITED_POWER_RATING,
          "kW",
        ),
        "RPM at limited power": formatTechFormMeasurement(stepSevenData?.MAIN_ENGINE_RPM_LIMITED_POWER, "RPM"),
        mainEngineSMCRRating: `${stepSevenData?.MAIN_ENGINE_SMCR_RATING} kW`,
        "Main Engine Normal Continuous Rating (NCR)": `${stepSevenData?.MAIN_ENGINE_NCR} kW`,
        "Main Engine RPM @ SMCR Rating": `${stepSevenData?.SMCR_RATING} RPM`,
        "Main Engine RPM @ NCR (ballast)": `${stepSevenData?.NCR_BALLAST} RPM`,
        "Main Engine RPM @ NCR (laden)": `${stepSevenData?.NCR_LADEN} RPM`,
        "Min Slow Steaming Main Engine %SMCR": `${stepSevenData?.MIN_SLOW_SMCR} %`,
        "Min slow steaming engine RPM": `${stepSevenData?.BLOCMINSLOW_STEAMING_ENGINE} RPM`,
        "Critical RPM Range - Upper": `${stepSevenData?.CRITICAL_RPM_UPPER} RPM`,
        "Critical RPM Range - Lower": `${stepSevenData?.CRITICAL_RPM_LOWER} RPM`,
        "Min Ultra Slow Steaming Main Engine %SMCR": stepSevenData?.MIN_ULTRA_SLOW_SMCR + " RPM",
        "Min ultra slow steaming rpm": `${stepSevenData?.MIN_ULTRA_SLOW_STREAMING_RPM} RPM`,
        "Aux blowers cut-off pressure point": `${stepSevenData?.AUX_BLOWERS_CUT_OFF} RPM`,
        "Aux blowers cut-in pressure point": `${stepSevenData?.AUX_BLOWERS_PRESSURE} Mpa`,
        "Is the vessel fitted with any energy saving devices?": stepSevenData?.IS_THE_VESSEL_FITTED,
        "Energy saving device details": stepSevenData?.ENERGY_SAVING_DEVICES_REMARKS,
      };
      setSlowStreamingForm(_slowStreamingForm);
      setIsLoading(false);
    } catch (error: unknown) {
      setIsLoading(false);
    }
  };
  const powerManagementFormFetchData = async () => {
    try {
      setIsLoading(true);
      const result = await api.get(`${apiUrl}/td_Power_Management_IndividualFields`, {
        params: queryParams,
      });
      const stepEightData = result.data[0];
      const _powerForm = {
        "aux Gensets Maker And Model": stepEightData?.AUX_GENSETS_MAKER_AND_MODEL,
        "no OF Aux Gensets": stepEightData?.NO_OF_AUX_GENSETS,
        "aux Gensets Power": stepEightData?.POWER_MGMT_AUX_GENSETS_POWER,
        "shaft Generator Fitted?": stepEightData?.SHAFT_GENERATOR_FITTED,
        "shaft Generator Rated Power": stepEightData?.SHAFT_GENERATOR_RATED_POWER,
        "Min Main Engine MCR for onloading shaft generator": formatTechFormMeasurement(
          stepEightData?.MIN_MAIN_ENGINE_MCR_FOR_SHAFT_GENERATOR,
          "%",
        ),
        "NOx Tier III compliance method": stepEightData?.NOX_TIER_III_COMPLIANCE_METHOD,
        "Aux boiler consumption @ 100% load": stepEightData?.AUX_BOILER_CONSUMPTION,
        "maker Type Heating Capacity": stepEightData?.MAKER_TYPE_HEATING_CAPACITY,
        "normal Electrical LoadAt Sea": stepEightData?.POWER_MGMT_NORMAL_ELECTRICAL_LOAD_AT_SEA,
        "normal Electrical Load in Port/At Anchor": stepEightData?.NORMAL_ELECTRICAL_LOAD_IN_PORT_AT_ANCHOR,
        "The usual “working” electrical load at sea": stepEightData?.USUAL_WORKING_ELECTRICAL_LOAD_AT_SEA,
        "The usual “working” electrical load in port/at anchor": stepEightData?.USUAL_WORKING_LOAD_PORT_AT_ANCHOR,
        "normal AEHFO Consumption AT Sea": stepEightData?.NORMAL_AEHFO_CONSUMPTION_AT_SEA,
        "mormal Fuel Consumption Auxiliary Boiler At Seal":
          stepEightData?.NORMAL_FUEL_CONSUMPTION_AUXILIARY_BOILER_AT_SEA,
        "normal Fuel Consumption Of Boiler In Port": stepEightData?.NORMAL_FUEL_CONSUMPTION_OF_BOILER_IN_PORT,
      };
      setPowerForm(_powerForm);

      const tableResult = await api.get(`${apiUrl}/td_Power_Management`, {
        params: queryParams,
      });

      const tableData = tableResult.data;
      setPowerManagementTableDataForm(tableData);
      setIsLoading(false);
    } catch (error: unknown) {
      setIsLoading(false);
    }
  };
  const portCallsFormFetchData = async () => {
    try {
      const result = await api.get(`${apiUrl}/td_Last_Port_Calls`, {
        params: queryParams,
      });
      const stepFiveData = result.data;
      setLastPortCallsForm(stepFiveData);
      setIsLoading(false);
    } catch (error: unknown) {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    vesselDetailsFormFetchData();
    vesselDesignFormsFormFetchData();
    draftFormsFormFetchData();
    antiFoulingFormFetchData();
    secaFormfetchData();
    slowStreamingFormFetchData();
    powerManagementFormFetchData();
    portCallsFormFetchData();
  }, []);

  return (
    <LoadingWrapper isLoading={isLoading} loadingIndicatorClassName="text-green" loadingIndicatorSize="lg">
      <div
        data-test="technical-information-tab"
        className={twMerge(
          "flex flex-col gap-4 overflow-y-auto",
          "[&::-webkit-scrollbar]:w-1.5",
          "[&::-webkit-scrollbar-track]:bg-transparent",
          "[&::-webkit-scrollbar-thumb]:rounded-full",
          theme.uwhcAssistant.tableScroll,
          theme.uwhcAssistant.scrolHover,
        )}
      >
        <div className={twMerge("rounded-lg p-6", theme.home.tailwind.panelBackground)}>
          <h1 className={twMerge("text-lg font-bold", theme.home.tailwind.textDefault)}>Vessel details</h1>
          <div className="flex items-center gap-2">
            <div className={twMerge("-mt-1 mb-1 pb-2 text-[11px]", theme.vesselDetails.info)}>
              Last submitted: {technicalFormSubmitted}
            </div>
            {technicalFormSubmittedOffline && (
              <span
                data-test="offline-tech-form-indicator"
                className="mb-2 inline-flex rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-800"
              >
                Offline submission
              </span>
            )}
            {technicalFormRejoinedFleet && (
              <span
                data-test="rejoined-fleet-tech-form-indicator"
                className="mb-2 inline-flex rounded-full bg-sky-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-sky-800"
              >
                Rejoined Fleet
              </span>
            )}
          </div>
          <DynamicReadOnlyForm data={vesselDetailsForm} colsCount={5} />
        </div>

        <div className={twMerge("flex flex-col gap-6 rounded-lg p-6", theme.home.tailwind.panelBackground)}>
          <div>
            <h2 className={twMerge("text-lg font-bold", theme.home.tailwind.textDefault)}>WLTHC</h2>
            <p className={theme.uwhcAssistant.text}>
              Distance from waterline to top of hatch coaming or top of hatch covers if side-rolling hatches
            </p>
          </div>
          <div className={twMerge("divide-y rounded-lg border", theme.uwhcAssistant.text, theme.uwhcAssistant.border)}>
            <div className={twMerge("flex h-14 w-full items-center text-xs font-semibold *:flex *:flex-1 *:px-4")}>
              <p>CONDITION</p>
              <p>No1. HATCH</p>
              <p>MIDSHIPS</p>
              <p>LAST HATCH</p>
            </div>

            <div
              className={twMerge(
                "flex h-14 w-full items-center text-xs *:flex *:flex-1 *:px-4",
                theme.uwhcAssistant.border,
              )}
            >
              <p className="font-semibold">BALLAST</p>
              <p>{wlthcForm?.WLTHC_BALLAST_NO1 ? `${wlthcForm?.WLTHC_BALLAST_NO1} m` : "-"}</p>
              <p>{wlthcForm?.WLTHC_BALLAST_MIDSHIPS ? `${wlthcForm?.WLTHC_BALLAST_MIDSHIPS} m` : "-"}</p>
              <p>{wlthcForm?.WLTHC_BALLAST_LAST ? `${wlthcForm?.WLTHC_BALLAST_LAST} m` : "-"}</p>
            </div>

            <div
              className={twMerge(
                "flex h-14 w-full items-center text-xs *:flex *:flex-1 *:px-4",
                theme.uwhcAssistant.border,
              )}
            >
              <p className="font-semibold">FULL BALLAST</p>
              <p>{wlthcForm?.WLTHC_FULL_BALLAST_NO1 ? `${wlthcForm?.WLTHC_FULL_BALLAST_NO1} m` : "-"}</p>
              <p>{wlthcForm?.WLTHC_FULL_BALLAST_MIDSHIPS ? `${wlthcForm?.WLTHC_FULL_BALLAST_MIDSHIPS} m` : "-"}</p>
              <p>{wlthcForm?.WLTHC_FULL_BALLAST_LAST ? `${wlthcForm?.WLTHC_FULL_BALLAST_LAST} m` : "-"}</p>
            </div>

            <div
              className={twMerge(
                "flex h-14 w-full items-center text-xs *:flex *:flex-1 *:px-4",
                theme.uwhcAssistant.border,
              )}
            >
              <p className="font-semibold">FULLY LADEN</p>
              <p>{wlthcForm?.WLTHC_FULLY_LADEN_NO1 ? `${wlthcForm?.WLTHC_FULLY_LADEN_NO1} m` : "-"}</p>
              <p>{wlthcForm?.WLTHC_FULLY_LADEN_MIDSHIPS ? `${wlthcForm?.WLTHC_FULLY_LADEN_MIDSHIPS} m` : "-"}</p>
              <p>{wlthcForm?.WLTHC_FULLY_LADEN_LAST ? `${wlthcForm?.WLTHC_FULLY_LADEN_LAST} m` : "-"}</p>
            </div>
          </div>
        </div>

        <div
          className={twMerge("rounded-lg p-6", theme.home.tailwind.panelBackground, theme.home.tailwind.textDefault)}
        >
          <h1 className={twMerge("mb-1 pb-2 text-lg font-bold")}>Vessel design</h1>
          <DynamicReadOnlyForm data={vesselDesignForm} colsCount={5} />
          <div className="grid grid-cols-2">
            <div className="">
              <p className="mb-1 py-3 text-sm font-bold">Ballasting rate using:</p>
              <DynamicReadOnlyForm data={vesselDesignBallastForm} colsCount={2} />
            </div>
            <div>
              <p className="mb-1 py-3 text-sm font-bold">De-Ballasting rate using:</p>

              <DynamicReadOnlyForm data={vesselDesignDeballastForm} colsCount={2} />
            </div>
          </div>
        </div>

        <div
          className={twMerge("rounded-lg p-6", theme.home.tailwind.panelBackground, theme.home.tailwind.textDefault)}
        >
          <h1 className="mb-1 pb-2 text-lg font-bold">Drafts</h1>
          <div className="w-1/2">
            <p className="mb-1 py-3 text-sm font-bold">Summer draft</p>
            <DynamicReadOnlyForm data={summerDraftForm} colsCount={3} />
          </div>
          <div className="w-1/2">
            <p className="mb-1 py-3 text-sm font-bold">Winter draft</p>

            <DynamicReadOnlyForm data={winterDraftForm} colsCount={3} />
          </div>
          <p className="mb-4 text-sm font-bold">Other drafts</p>
          <div className="w-1/2">
            {otherDraftForm?.length > 0 && (
              <ResponsiveTable data={otherDraftForm} displayKeys={["DRAFT", "DWT", "TPC"]} />
            )}
          </div>
        </div>

        <div
          className={twMerge(
            "mb-4 rounded-lg p-6",
            theme.home.tailwind.panelBackground,
            theme.home.tailwind.textDefault,
          )}
        >
          <h1 className="mb-1 pb-2 text-lg font-bold">Under-water hull cleaning</h1>
          <div>
            {antiFoulingDetailsFormTable?.length > 0 && (
              <ResponsiveTable
                data={antiFoulingDetailsFormTable?.map((item) => ({
                  ...item,
                  DATE: formatDate(item.DATE),
                }))}
                displayKeys={[
                  "PORT",
                  "DATE",
                  "HULL INSPECTED",
                  "HULL CLEANED",
                  "AREAS CLEANED",
                  "PROPELLER POLISHED",
                  "NZ MPI STANDARD",
                ]}
              />
            )}
          </div>
        </div>

        <div
          className={twMerge("rounded-lg p-6", theme.home.tailwind.panelBackground, theme.home.tailwind.textDefault)}
        >
          <h1 className="mb-1 pb-2 text-lg font-bold">Antifouling details</h1>
          <DynamicReadOnlyForm data={antiFoulingDetailsForm} colsCount={5} />
        </div>

        <div
          className={twMerge("rounded-lg p-6", theme.home.tailwind.panelBackground, theme.home.tailwind.textDefault)}
        >
          <h1 className="mb-1 pb-2 text-lg font-bold">SECA</h1>
          <DynamicReadOnlyForm data={secaForm} colsCount={5} />
        </div>

        <div
          className={twMerge("rounded-lg p-6", theme.home.tailwind.panelBackground, theme.home.tailwind.textDefault)}
        >
          <h1 className="mb-1 pb-2 text-lg font-bold">Slow steaming</h1>
          <DynamicReadOnlyForm data={slowStreamingForm} colsCount={5} />
        </div>

        <div
          className={twMerge("rounded-lg p-6", theme.home.tailwind.panelBackground, theme.home.tailwind.textDefault)}
        >
          <h1 className="mb-1 pb-2 text-lg font-bold">Power management</h1>
          <DynamicReadOnlyForm data={powerForm} colsCount={5} />

          <div className="mb-4 rounded-lg pt-3">
            {powerManagementTableDataForm?.length > 0 && (
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className={twMerge("border", theme.uwhcAssistant.border)}>
                      <th className="h-14 px-4 py-2 text-left text-xs font-semibold">ITEM</th>
                      <th className="h-14 px-4 py-2 text-left text-xs font-semibold">QUANTITY</th>
                      <th className="h-14 px-4 py-2 text-left text-xs font-semibold">POWER CONSUMPTION</th>
                      <th className="h-14 px-4 py-2 text-left text-xs font-semibold">TYPE OF POWER</th>
                      <th className="h-14 px-4 py-2 text-left text-xs font-semibold">MAKER/MODEL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {powerManagementTableDataForm?.map((row: any, rowIndex: number) => (
                      <tr key={rowIndex} className={twMerge("border", theme.uwhcAssistant.border)}>
                        <td className="h-14 px-4 py-2 text-xs">{row.NAME}</td>
                        <td className="h-14 px-4 py-2 text-xs">{row.NO_OF_ITEMS}</td>
                        <td className="h-14 px-4 py-2 text-xs">{row.POWER_CONSUMPTIONS}</td>
                        <td className="h-14 px-4 py-2 text-xs">{row.TYPE_OF_POWER}</td>
                        <td className="h-14 px-4 py-2 text-xs">{row.MAKER_MODEL}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        <div
          className={twMerge("rounded-lg p-6", theme.home.tailwind.panelBackground, theme.home.tailwind.textDefault)}
        >
          <h1 className="mb-1 pb-2 text-lg font-bold">Last port calls</h1>
          <div className="mb-4 rounded-lg pt-3">
            {lastPortCallsForm?.length > 0 ? (
              <div className="overflow-x-auto">
                <table className="min-w-full">
                  <thead>
                    <tr className={twMerge("border", theme.uwhcAssistant.border)}>
                      <th className="h-14 px-4 py-2 text-left text-xs font-semibold">#</th>
                      <th className="h-14 px-4 py-2 text-left text-xs font-semibold">PORT</th>
                      <th className="h-14 px-4 py-2 text-left text-xs font-semibold">ACTIVITY</th>
                      <th className="h-14 px-4 py-2 text-left text-xs font-semibold">FROM</th>
                      <th className="h-14 px-4 py-2 text-left text-xs font-semibold">TO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lastPortCallsForm.map((row: any, rowIndex) => (
                      <tr key={rowIndex} className={twMerge("border", theme.uwhcAssistant.border)}>
                        <td className="h-14 px-4 py-2 text-xs">{rowIndex + 1}</td>
                        <td className="h-14 px-4 py-2 text-xs">{row.PORT}</td>
                        <td className="h-14 px-4 py-2 text-xs">{row.ACTIVITY_VALUE}</td>
                        <td className="h-14 px-4 py-2 text-xs">{formatDate(row.FROM_DATE)}</td>
                        <td className="h-14 px-4 py-2 text-xs">{formatDate(row.TO_DATE)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="py-2">
                <div className={twMerge("text-custom-label text-xs font-normal", theme.vesselDetails.fields)}>
                  No data available
                </div>
              </div>
            )}
          </div>
        </div>

        <PageFooter />
      </div>
    </LoadingWrapper>
  );
};

export default TechnicalInformationTab;
